import React from 'react';
import classNames from 'classnames/bind';
import times from 'lodash/times';
import styles from "./styles.pcss";
import { Skeleton } from "./Skeleton";
var cx = classNames.bind(styles);
export var SkeletonLayout = function SkeletonLayout(_ref) {
  var children = _ref.children,
    isLoading = _ref.isLoading;
  if (!isLoading) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: cx('taps')
  }, /*#__PURE__*/React.createElement("ul", {
    className: cx('taps__list')
  }, times(5, function (index) {
    return /*#__PURE__*/React.createElement("li", {
      className: cx('taps__tap'),
      key: index
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: cx('taps__tap', 'figure')
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: cx('cell')
  }, /*#__PURE__*/React.createElement("ul", {
    className: cx('cell-content')
  }, times(5, function (index) {
    return /*#__PURE__*/React.createElement("li", {
      className: cx('details'),
      key: index
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: cx('details-icon', 'figure__square')
    }), /*#__PURE__*/React.createElement("div", {
      className: cx('details-info')
    }, /*#__PURE__*/React.createElement(Skeleton, {
      className: cx('details-info__title', 'figure')
    }), /*#__PURE__*/React.createElement(Skeleton, {
      className: cx('details-info__subtitle', 'figure')
    })));
  }))));
};